import { useState } from "react";
import { useHistory } from "react-router";
import { RouteEnum } from "../routes/routes";
import {
  DEVICE_SETTINGS_NAME,
  getData,
  setData,
} from "../services/localStorage";

export const usePage = (): [RouteEnum, (route: RouteEnum) => void] => {
  const history = useHistory();
  const [page, setPage] = useState<RouteEnum>(
    getData(DEVICE_SETTINGS_NAME).page || RouteEnum.DASHBOARD
  );

  const onPageChange = (newRoute: RouteEnum) => {
    setData(DEVICE_SETTINGS_NAME, {
      ...getData(DEVICE_SETTINGS_NAME),
      page: newRoute,
    });
    if (page !== newRoute) history.push(newRoute);
    setPage(newRoute);
  };

  return [page, onPageChange];
};
